export default __webpack_public_path__ + "6504d88a31d77bd043c61e73603dbc00.png";